import { useState } from "react";
import Swal from "sweetalert2";
import ReactMarkdown from "react-markdown";
import useProjectStore from "../../../hooks/useProjectStore";
import AiraStar from "../../../assets/img/logo-mjv-aira-star.svg"
import { FaRegEdit, FaRegCopy  } from "react-icons/fa";
import { FaArrowsRotate } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

import Subtitle from "../../Atoms/Subtitle";
import TextArea from "../../Atoms/TextArea";

export default function SummaryProjectTemplate({ generateSummary, loading }) {
    const navigate = useNavigate();

    const [editView, setEditView] = useState(false);

    const { 
        projectSummary,
        setProjectSummary,
        resetProject
    } = useProjectStore();

    const SummaryProjectStyles = {
        actionButtonContainerStyles: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1px',
            border: '1px solid #314158',
            borderRadius: '10px'
        },
        confirmButton: {
            backgroundColor: '#8E51FF',
            fontWeight: 'bold',
            padding: '10px 20px',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
        },
        confirmButtonDisabled: {
            backgroundColor: '#6B7280',
            fontWeight: 'bold',
            padding: '10px 20px',
            color: '#9CA3AF',
            border: 'none',
            borderRadius: '6px',
            cursor: 'not-allowed'
        },
        cancelButton: {
            backgroundColor: 'transparent', 
            border: '1px solid #314158',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '6px'
        }
    }

    const handleCancel = () => {
        Swal.fire({
            position: "top-end",
            title: "Rascunho excluído com sucesso",
            showConfirmButton: false,
            timer: 1800,
            background: '#27272A',
            color: '#fff',
        });

        resetProject();
        navigate('/projects');
    }

    const handleCopy = () => {
        Swal.fire({
            position: "top-end",
            title: "Resumo copiado",
            showConfirmButton: false,
            timer: 1000,
            background: '#27272A',
            color: '#fff',
        });

        navigator.clipboard.writeText(projectSummary);
    }

    const handleApprove = () => {
        if (projectSummary === '') {
            Swal.fire({
                position: "top-end",
                title: "Você não pode prosseguir com o resumo vazio",
                showConfirmButton: false,
                timer: 2000,
                background: '#27272A',
                color: '#fff',
            });
        } else {
            navigate('/review-project');
        }
    }

    return (
        <div className="container-xxl my-5">
            <div id="summary-project-header" className="mb-5">
                <h1>Resumo do projeto</h1>

                <Subtitle>
                    A IA analisou as informações fornecidas e gerou o contexto que será usado como base para todos artefatos deste projeto
                </Subtitle>
            </div>

            {loading ? (
                <div className="d-flex flex-row justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div id="summary-project-content" className="mb-5">
                    {editView ? (
                        <>
                            <TextArea
                                value={projectSummary}
                                onChange={(e) => setProjectSummary(e.target.value)}
                                style={{
                                    height: '400px',
                                }}
                            />

                            <div className="d-flex flex-row justify-content-end">
                                <button
                                    className="btn"
                                    onClick={() => setEditView(false)}
                                >
                                    Salvar
                                </button>
                            </div>
                        </>
                    ) : (
                        <ReactMarkdown>
                            {projectSummary}
                        </ReactMarkdown>
                    )}
                </div>
            )}


            {!editView && (
                <div id="summary-project-actions" className="mb-5">
                    <div className="d-flex flex-row justify-content-between">
                        <div>
                            <img src={AiraStar} alt="Aira Star" />
                        </div>

                        <div style={SummaryProjectStyles.actionButtonContainerStyles}>
                            <button
                                className="btn"
                                onClick={() => setEditView(true)}
                            >
                                <FaRegEdit />
                            </button>

                            <button
                                className="btn"
                                onClick={handleCopy}
                            >
                                <FaRegCopy />
                            </button>

                            <button
                                className="btn"
                                onClick={generateSummary}
                            >
                                <FaArrowsRotate />
                            </button>
                        </div>
                    </div>          
                </div>
            )}


            <div id="summary-project-footer">
                <div className='w-auto d-flex flex-row justify-content-end gap-3'>
                    <button
                        className='btn'
                        onClick={handleCancel}
                        style={SummaryProjectStyles.cancelButton}
                    >
                        Cancelar
                    </button>

                    <button
                        className='btn'
                        onClick={handleApprove}
                        style={editView ? SummaryProjectStyles.confirmButtonDisabled : SummaryProjectStyles.confirmButton}
                        disabled={editView || loading}
                    >
                        Aprovar resumo
                    </button>
                </div>
            </div>
        </div>
    )
}